export default __webpack_public_path__ + "static/media/turkish.1e0d1339.png";